import { updates } from '@/mocks/siteData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">影视圈快讯实时滚动，不错过任何一颗瓜</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 pl-12">
                <div className="absolute left-[12px] top-1.5 w-4 h-4 rounded-full border-2 border-primary-500 bg-background-50 flex-shrink-0"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColorMap[item.tagColor] || tagColorMap.primary}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-foreground-800 text-sm md:text-base leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}